module.exports = __webpack_public_path__ + "img/f8c8536ba805281da55db5dc53ccc638.png";